import { baseApi } from '@/shared/api'
import type { AppendToInvoiceBody, AppendToInvoiceResult } from '../model/operations'
import type { ReserveFromCartBody, ReserveFromCartResult } from '../model/types'

/** Оформление корзины клиента; резервы и счета — `orderLineApi.ts`. */
export const orderApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Резерв из корзины: сервер переносит строки в заказ, отправляет заявку в 1С и очищает
     * корзину. Поэтому перечитываются корзина, строки резервов, счета и очередь команд 1С.
     */
    reserveFromCart: build.mutation<ReserveFromCartResult, ReserveFromCartBody>({
      query: (body) => ({ url: '/orders/from-cart', method: 'POST', body }),
      invalidatesTags: [
        { type: 'Order', id: 'LINES' },
        { type: 'Order', id: 'INVOICES' },
        { type: 'Cart', id: 'LIST' },
        { type: 'Cart', id: 'SUMMARY' },
        { type: 'Command', id: 'LIST' },
      ],
    }),

    /**
     * Дозаказать корзину в существующий счёт (`POST /v1/orders/{invoiceNo}/from-cart`). Счёт —
     * только из «Добавить в» (`GET /v1/orders/invoices`). `own` → файл `<счёт>.add` в 1С, ответ
     * несёт `commandId` (команда `invoice.append`): дальше опрос. `order-rb`/`pc-build` → строки
     * ложатся без файла, `commandId = null` — готово сразу. Корзина и счета перечитываются.
     */
    appendCartToInvoice: build.mutation<
      AppendToInvoiceResult,
      { invoiceNo: string } & AppendToInvoiceBody
    >({
      query: ({ invoiceNo, ...body }) => ({
        url: `/orders/${encodeURIComponent(invoiceNo)}/from-cart`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [
        { type: 'Order', id: 'LINES' },
        { type: 'Order', id: 'INVOICES' },
        { type: 'Cart', id: 'LIST' },
        { type: 'Cart', id: 'SUMMARY' },
        { type: 'Command', id: 'LIST' },
      ],
    }),
  }),
})

export const { useReserveFromCartMutation, useAppendCartToInvoiceMutation } = orderApi
